import { useState } from "react";
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { Paper, Grid, } from "@mui/material";
import Header from "./Header";
import LessorFilter from "./LessorFilter";
import AssetFilter from "./AssetFilter";
import { EndDateFilter, StartDateFilter } from "./DateFilter";
import { getUtilizationInvoiceReportApi } from "../apiService";
import { globalPostService } from "../../../utils/globalApiServices";
import { checkApiStatus } from "../../../utils";
import { ExportMenu, PageLoader } from "../../../shared_elements";
import { isValidYearRange } from "../../../utils/helper";
import { trackActivity } from "../../../utils/mixpanel";

const AssetUtilizationInvoicesReport = ({pltConstants,dropDownLoader}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false)
  const [reportData, setReportData] = useState();
  const [error, setError] = useState({});
  const onFieldChange = (key, value) => {
    setReportData((prev) => {
      const updatedData = { ...prev, [key]: value };
      if (key === "start_date" && !value) { updatedData.end_date = null; }
      return updatedData;
    });
  };  
  const onFocusChange = (keyParam) => { setError(prev => ({ ...prev, [keyParam]: '' })) }
  const onExportReport = (extention,) => {
    let validationInputs = {};
    validationInputs = {
      start_date: !reportData?.start_date ? "Please select Start Date" : !isValidYearRange(reportData?.start_date) ? "Year must be between 1900 and 2100." : "",
      end_date: !reportData?.end_date ? "Please select End Date" : moment(reportData.end_date).isBefore(moment(reportData.start_date)) ? "End date must be after Start Date" : !isValidYearRange(reportData?.end_date) ? "Year must be between 1900 and 2100." : "",
      asset_type_id: reportData?.asset_type_id?.length > 0 ? "" : "Please select Asset",
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      const payload = { ...reportData, file_type: extention ,...(reportData?.asset_type_id?.length && {asset_id: reportData.asset_type_id, }),}
      setLoading(true)
      globalPostService(getUtilizationInvoiceReportApi(), payload)
        .then(response => {
          setLoading(false)
          if (checkApiStatus(response)) {
            setReportData({})
            setError({});
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
            trackActivity('Item Export', { page_title: `Asset Utilisation and Invoices Report`, success_msg: response?.data?.message, payload: payload, response: response?.data })
          } else {
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
            trackActivity('Item Export', { page_title: `Asset Utilisation and Invoices Report`, error_msg: response?.data?.message, payload: payload, response: response?.data })
          }
        });
    } else {
      setError(validationInputs)
      trackActivity('Item Export', { page_title: `Asset Utilisation and Invoices Report`, error_msg: validationInputs })
    }
  };
  return (
    <Paper square>
      <div className='custom-rpt-card'>
        <div className='rpt-card-header'>
          <Grid container spacing={1} className='rpt-header-grid'>
            <Grid size={{ md: 10, xs: 10 }}>
              <Header title="Asset Utilisation and Invoices Report" description="" />
            </Grid>
            <Grid size={{ md: 2, xs: 2 }} sx={{ display: "flex", justifyContent: "flex-end",alignItems: "center"  }}>
              <ExportMenu
                exportReportFn={(file) => onExportReport(file.extension)}
                files={[{ title: 'EXCEL', extension: 'xlsx' }, { title: 'CSV', extension: 'csv' }]}
              />
            </Grid>
          </Grid>
        </div>
        <Grid sx={{ padding: 2 }} container spacing={1} >
          <Grid size={{ md: 6, xs: 12 }} >
            <StartDateFilter reportData={reportData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} error={error} isFutureDisabled={true} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <EndDateFilter reportData={reportData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} error={error} disabled={!reportData?.start_date} />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }} >
          <LessorFilter pltConstants={pltConstants} dropDownLoader={dropDownLoader} reportData={reportData} onFieldChange={onFieldChange}/>
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
          <AssetFilter isRequired={true} error={error} pltConstants={pltConstants} dropDownLoader={dropDownLoader} reportData={reportData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} />
          </Grid>
        </Grid>
      </div>
      {isLoading ? <PageLoader /> : null}
    </Paper>
  )
}

export default AssetUtilizationInvoicesReport